import React, { Component } from 'react'
import ResetPassword from '../../old_Components/ForgotPassword/resetPassword'
import queryString from 'query-string';
import Swal from 'sweetalert2';
import { resetPasswRecruiterUser } from '../../action/auth';
export default class resetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    onSubmit = (model) => {
        const qParam = queryString.parse(this.props?.location?.search)
        // console.log(qParam)
        // model.t = qParam.t
        model.e = qParam.e
        console.log(model)
        model.header = {
            headers: { Authorization: "Bearer " + qParam.t }
        };
        resetPasswRecruiterUser(model).then(res => {
            if (res.status) {
                Swal.fire({
                    icon: 'success',
                    text: 'Password Updated Successfully',
                    timer: 5000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 1500,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
        }).catch(err => {
            Swal.fire({
                icon: 'error',
                text: err,
                timer: 1500,
                showCancelButton: false,
                showConfirmButton: false
            })
        })
    }
    render() {
        return (
            <React.Fragment>
                <ResetPassword
                    onSubmit={this.onSubmit} />
            </React.Fragment>)
    }
}
